@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/bb-chart.scss';

:host {
  color: var(--main-titles-inputs-600);
  padding-top: calc(var(--spacer) * 1.5);
}

.wrapper {
  flex-direction: column;
  justify-content: space-between;
  min-height: 240px;

  .body-copy {
    max-width: 85%;
  }

  &.is-missing-license {
    .widget-missing-license {
      display: block;
      margin: calc(var(--spacer) * 1.5) 0;
    }
  }

  &.is-loading,
  &.is-missing-license {
    .threats-list {
      display: none;
    }
  }

  &.is-loading {
    .gauge-container {
      display: none;
    }
  }
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
}

.widget-loading {
  bottom: calc(var(--spacer) * 3);
}

.gauge-container {
  height: 125px;
  width: 220px;
  margin: 0 auto;
}

.threats-list {
  margin-top: calc(var(--spacer) * 1.5);
  li {
    margin: 0;

    .gz-data-item--title {
      font-family: var(--font-family-secondary);
      font-size: var(--body-size-medium);
    }
  }
}

.wrapper {
  .content {
    .gz-data-item {
      &--value {
        color: var(--main-titles-inputs-600);
      }

      &--delta {
        font-weight: bold;

        &.success {
          color: var(--green-layout-101-primary-green);
        }
      }
    }
  }
}

:host([data-display-mode='pdf']) {
  .wrapper {
    .content {
      .gz-data-item {
        font-size: calc(var(--body-size) - 2px);
      }
    }
  }

  .gz-data-item--value {
    margin-bottom: auto;
    margin-top: auto;
    font-size: var(--body-size);
  }
}
